// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3TIPI","productName":"Table_productName__3fJ9B"};